<!-- 设置设备监控 -->
<template>
    <div class='container containerBox tcs-box'>
        <div class="tcs-headerbox">
            <div class="headerbox-left">{{ name }}</div>
            <div class="headerbox-right">
                <el-button type="text" icon="el-icon-upload"  @click="handleUpload">上传平面图纸</el-button>
                <el-button type="text" icon="el-icon-document" @click="handleSave">保存</el-button>
                <el-button type="text" icon="el-icon-rank" @click="handleFull">全屏查看</el-button>
                <el-button type="text" icon="el-icon-delete" @click="handleDeteleNode">删除节点</el-button>
                <el-button type="text" icon="el-icon-delete" @click="handleDeteleAll">清空</el-button>
            </div>
        </div>
       <div class="tcs-contentbox">
            <div class="tcs-toolbox">
                <p class="nodeinfo-title">设备列表 
                    <el-tooltip class="item" effect="dark" content="将设备列表的设备拖拽至中间画板区" placement="right-start">
                        <i class="el-icon-info" style="font-size:12px;vertical-align: text-top;margin: 0 0 0 5px;"></i>
                    </el-tooltip>
                 </p>
                <div class="toolbox-chose_build">
                    <cmp-build-select-meter 
                            :buildRoom="buildRoom"
                            changeOnSelect
                            @listenBuildResult="listenBuildResult"></cmp-build-select-meter>
                </div>
                <ul class="toolbox-list">
                    <li class="toolbox-item" v-for="(v) in meterList" :key="v.oid">
                        <div class="toolbox-imgs" topo-div-type="topo-node" topo-nodetype="DE" draggable="true" :topo-nodeoid="v.oid" :topo-nodeMeterInfo="`${v.house_name}$${v.terminal_serial}$${v.collector_serial}$${v.dev_type}`">
                            <div class="meter-item-img">
                                <img class="node-icon-style" :src="v.dev_type == 1 ? '/static/images/img-wkq.png': '/static/images/img-fg.png'" />
                            </div>
                            <div class="meter-item-info">{{v.house_name}}：{{v.terminal_serial}}</div>
                        </div>
                    </li>
                </ul>
                <p v-if="meterList.length<=0" class="nodata">暂无表计</p>
            </div>
            <div class="tcs-infobox" id="nodeInfo">
                <p class="nodeinfo-title">节点信息</p>
                <p class="nodeinfo-item">
                    <span>表计序列号：</span>
                    <span class="TerminalSerial"></span>
                </p>
                <p class="nodeinfo-item">
                    <span>设备类型：</span>
                    <span class="CollectorSerial"></span>
                </p>
                <p class="nodeinfo-item">
                    <span>安装位置：</span>
                    <span class="HouseName"></span>
                </p>
                <p class="nodeinfo-item">
                    <span>所属集控器：</span>
                    <span class="CollectorSerial"></span>
                </p>
            </div>
            <div class="tcs-canvasbox" id="topology-body">
                <canvas class="topology-context" id="topology-canvas"></canvas>
            </div>
       </div>

       <!-- 上传图纸组件 -->
       <cmp-tcs-upload :visible="visibleUpload" :name="name" @handleCloseDialog="handleCloseDialog"></cmp-tcs-upload>
    </div>
</template>

<script>
import Service from '@/api/Service'
import CmpBuildSelectMeter from '@/components/CmpBuildSelect/CmpBuildSelectMeter'
import CmpTcsUpload from './CmpTcsUpload'

export default {
    name:  'terminalcontrolset',
    data() {
        return {
            meterList: [],     //  表计列表
            name: '监控设置',
            // 选择房间组件
            buildRoom: {},
            OID: '',
            // 上传
            visibleUpload: false,
        };
    },
    components: {
        CmpBuildSelectMeter,
        CmpTcsUpload
    },
    mounted() {
        let OID = this.$route.params.OID
        this.$nextTick(()=>{
            if(OID != 0) {
                // 编辑
                this.getTCSinfo(OID);
                this.OID = OID;
            }else {
                // 新增
                 // 拓扑不存在,创建一个空白的拓扑图
                let initTopologyJson = {
                    'version': '0.4.8',
                    'wheelZoom': 1,
                    'width': 972,
                    'height': 569,
                    'id': 'ST172.19.105.52015100809430700001',
                    'childs': [
                        {
                            'elementType': 'scene',
                            'id': 'S172.19.105.52015100809430700002',
                            'translateX': 0,
                            'translateY': 0,
                            'scaleX': 1,
                            'scaleY': 1,
                            'childs': []
                        }
                    ]
                }
                editor.init('', '', initTopologyJson, '')
            }
        })
    },
    created() {
        
    },
    methods: {
        // 获取
        async getTCSinfo(oid) {
            let data = await Service.getEmcsInfo({oid: oid});
            if(data) {
                this.name = data.map_name;
                let map_value = JSON.parse(data.map_value);
                editor.init('', '', map_value, '');
            }
        },
        // 左侧工具栏
        changeContent(key) {
            this[key]= !this[key];
        },
        // 上传平面图
        handleUpload() {
            this.visibleUpload = true;
        },
        // 全屏查看
        handleFull() {
            editor.utils.showInFullScreen(editor.stage.canvas,'RequestFullScreen')
        },
        // 保存
        handleSave() {
            editor.saveTopology(true, (jsonData)=>{
                let data = {
                    map_name: this.name,
                    map_value: jsonData
                }
                data.terminal_oid = this.getTerminalOids(jsonData);
                
                if(data.map_name == "监控设置") {
                    this.$notify({
                        title: '警告',
                        message: '请输入上传平面图纸',
                        type: 'warning'
                    });
                    return
                }
                // if(data.terminal_oid.length<=0) {
                //     this.$notify({
                //         title: '警告',
                //         message: '请选择监控设备',
                //         type: 'warning'
                //     });
                //     return
                // }
                this.addEmcs(data)
            })
        },
        async addEmcs(params) {
            let data
            if(this.OID) {
                // 编辑
                params.oid = this.OID;
                data = await Service.editEmcs(params);
            }else{
                data = await Service.addEmcs(params);
            }
            
            if(data) {
                this.$message({
                    message: '操作成功',
                    type: 'success',
                });
            }
            this.$router.push('/terminalcontrollist')
        },
        // 获取全部OID集合
        getTerminalOids(data) {
            let list = JSON.parse(data);
            let oids = [];
            if(list && list.childs && list.childs[0].childs) {
                let nodeList = list.childs[0].childs;
                nodeList.map(v=>{
                    if(v.nodeType === 'DE'){
                        oids.push({oid: v.nodeParams.nodeOID})
                    }
                })
            }
            return oids
        },
        // 删除节点
        handleDeteleNode() {
            editor.utils.deleteSelectedNodes()
        },
        // 清空
        handleDeteleAll() {
            editor.utils.clearTopology()
        },
        //  获取楼层下面全部表计
        async listenBuildResult(item) {
			let is_house
			if(item.householdid === undefined) {
				// 建筑
				is_house = false
			}else{
				// 房间
				is_house = true
			}
            let data = await Service.getMeterDeviceList({moduleid: item.oid,is_house:is_house});
            data = data === 'success' ? [] : data;
            // 排除热量表
            this.meterList = data.filter(v=>{
                return v.dev_type !=3
            })
            
            this.bindClick();
        },
        // 重新绑定拖拽事件
        bindClick() {
            this.$nextTick(()=>{
                var canvas = document.getElementById("topology-canvas");
                    
                // 节点树中每个节点的拖放动作定义给拓扑图编辑器
                var nodes = $("[topo-div-type='topo-node']");
                var nodeLength = nodes.length;
                for (var i = 0; i < nodeLength; i++) {
                    editor.drag(nodes[i], canvas, '');
                }
            })
        },
        handleCloseDialog(data) {
            if(data.flag){
               this.name = data.data.name
               if(!data.data.imageUrl){
                   this.visibleUpload = false;
                   return
               }
                //    图片宽高
               let w_img = data.data.w_img;
               let h_img = data.data.w_img;
               const imgMax = 800;  //  图片最大尺寸

               if(w_img>=h_img && w_img>imgMax){
                   h_img = imgMax/w_img * h_img;
                   w_img = imgMax; 
               }
               if(h_img>=w_img && h_img>imgMax) {
                    w_img = imgMax/h_img * w_img;
                    h_img = imgMax; 
               }
               let node = new JTopo.Node()
                // 节点坐标
                node.setBound(0,0, w_img, h_img )
                // 节点图片
                node.setImage(data.data.imageUrl)
                // 节点数据
                node.nodeId = generateUUID()
                node.nodeType = 'BG'
                node.nodeImage = data.data.imageUrl;
                node.zIndex = 11;
                editor.scene.add(node);
                editor.utils.showInCenter();    // 居中显示  
            }
            this.visibleUpload = false;
        },
    }
}

</script>
<style lang='less' scoped>
    .tcs-box{
        height: calc(100% - 60px);
        padding: 0;
        .tcs-headerbox{
            width: 100%;
            height: 60px;
            line-height: 60px;
            border-bottom: 1px solid rgb(203, 211, 224);
            background-color: rgb(246, 247, 251);
            display: flex;
            display: -webkit-flex;
            flex-direction: row;
            justify-content: space-between;
            .headerbox-left{
                width: 200px;
                text-align: center;
                font-size: 20px;
            }
            .headerbox-right{
                margin-right: 20px;
                button{
                    font-size: 14px;
                    margin-right: 10px;
                }
            }
        }
        .tcs-contentbox{
            overflow: hidden;
            height: calc(100% - 60px);
            .tcs-toolbox{
                float: left;
                width: 300px;
                height: 100%;
                border-right: 1px solid #ccc;
                background-color: rgb(246, 247, 251);
                .toolbox-chose_build{
                    margin: 10px;
                }
                .toolbox-list{
                    height: calc(100% - 130px);
                    overflow-y: auto;
                }
                .toolbox-item{
                    &:nth-child(2n-1){
                        background-color: #e2f0ff;
                    }
                    .toolbox-imgs{
                        display: flex;
                        display: -webkit-flex;
                        flex-direction: row;
                        flex-wrap: wrap;
                        padding:5px 10px;
                        .meter-item-img{
                            display: inline-block;
                            text-align: center;
                            font-size: 0;
                            vertical-align: middle;
                            margin-right: 5px;
                        }
                        .meter-item-info{
                            flex: 1;
                            vertical-align: middle;
                            text-align: left;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            white-space: nowrap;
                            cursor: pointer;
                            display: inline-block;
                            font-size: 14px;
                            line-height: 32px;
                            &:hover{
                                color: @primary-color;
                            }
                        }
                    }
                }
            }
            .tcs-infobox{
                float: right;
                width: 200px;
                height: 100%;
                border-left: 1px solid #ccc;
                background-color: rgb(246, 247, 251);
                .nodeinfo-item{
                    display: none;
                    font-size: 14px;
                    color: #666;
                    margin:0 10px;
                    margin-bottom: 10px;
                    span{
                        display: block;
                        line-height: 30px;
                    }
                }
            }
            .tcs-canvasbox{
                margin: 0 200px 0 300px;
                padding: 15px;
                background-color: rgb(226, 229, 236);
                height: 100%;
            }
            .nodeinfo-title{
                height: 42px;
                line-height: 42px;
                color: #333;
                background-color: #f2f2f2;
                font-size: 16px;
                font-weight: 400;
                margin-bottom: 20px;
                text-align: center;
            }
        }
    }

</style>